import type { Resource } from '../../';
export const general_expand: Resource = {"default":"Expand"};
